const status = {
  AWAITING: 'Awaiting Payment',
  PARTIAL: 'Partially Paid',
  PAID: 'Paid',
  VOIDED: 'Voided',
  PROCESSING: 'Processing',
  CANCELLED: 'Canceled',
};

export default status;
